module.exports = __webpack_public_path__ + "img/mekuvanmodal.ea0e6abd.svg";